import { useEffect, useRef, useState } from "react";

const LEGAL = [
  ["Terms", "https://anomalos.com/legal/terms"],
  ["Privacy Policy", "https://anomalos.com/legal/privacy"],
  ["Cookie Policy", "https://anomalos.com/legal/cookies"],
] as const;

export const AuthFooter = () => {
  const footerRef = useRef<HTMLElement>(null);
  const [stacked, setStacked] = useState(false);
  const year = new Date().getFullYear();

  useEffect(() => {
    const footer = footerRef.current;
    if (!footer) {
      return;
    }
    const host = document.createElement("div");
    host.setAttribute("aria-hidden", "true");
    host.style.position = "absolute";
    host.style.width = "0";
    host.style.height = "0";
    host.style.overflow = "hidden";
    host.style.pointerEvents = "none";
    const clone = footer.cloneNode(true) as HTMLElement;
    clone.style.visibility = "hidden";
    clone.style.whiteSpace = "nowrap";
    clone.style.width = "max-content";
    clone.style.pointerEvents = "none";
    host.append(clone);
    footer.parentElement?.append(host);
    let wrapped = false;
    const measure = () => {
      const needed = clone.scrollWidth;
      const available = footer.clientWidth;
      if (!wrapped && needed > available) {
        wrapped = true;
      } else if (wrapped && needed + 8 < available) {
        wrapped = false;
      }
      setStacked(wrapped);
    };
    const observer = new ResizeObserver(measure);
    observer.observe(footer);
    measure();
    return () => {
      observer.disconnect();
      host.remove();
    };
  }, []);

  return (
    <footer
      className={
        stacked
          ? "flex flex-col items-center gap-2.5 text-center text-[13px] text-n-600"
          : "flex flex-row flex-wrap items-baseline justify-between gap-x-6 gap-y-2.5 text-[13px] text-n-600"
      }
      ref={footerRef}
    >
      <span>© {year} Anomalos, Inc. and its affiliates.</span>
      <nav
        aria-label="Legal"
        className={
          stacked
            ? "flex flex-wrap justify-center gap-x-6 gap-y-2"
            : "flex flex-wrap gap-x-6 gap-y-2"
        }
      >
        {LEGAL.map(([label, href]) => (
          <a
            className="auth-focus auth-underline text-n-600"
            href={href}
            key={href}
            rel="noopener noreferrer"
            target="_blank"
          >
            {label}
          </a>
        ))}
      </nav>
    </footer>
  );
};
